<h3 mat-dialog-title>{{ args.title }}</h3>
<mat-dialog-content>
  <div class="help-text" *ngIf="args.helpText">
    {{ args.helpText }}
  </div>
  <ul>
    <li *ngFor="let token of args.message.tokens">
      {{ token.token }} - {{ settings.lang.willBeReplacedBy }}
      {{ token.caption }} ({{ token.value }})
    </li>
  </ul>

  <textarea [(ngModel)]="args.templateText" class="form-control"></textarea>
  <H4>{{ settings.lang.sampleMessage }} ({{ testSms().length }} תוים)</H4>
  <pre>{{ testSms() }}</pre>
</mat-dialog-content>
<mat-dialog-actions
  style="
    display: flex;
    gap: 16px;
    place-content: center;
    flex-wrap: wrap;
    margin-top: 16px;
  "
>
  <button type="button" mat-raised-button color="accent" [mat-dialog-close]>
    {{ settings.lang.cancel }}
  </button>
  <button
    mat-raised-button
    *ngFor="let b of args.buttons"
    (click)="b.click(getButtonArgs())"
  >
    {{ b.name }}
  </button>
  <app-dots-menu
    [buttons]="args.moreButtons"
    *ngIf="args.moreButtons?.length > 0"
  ></app-dots-menu>
</mat-dialog-actions>
